// extracted by mini-css-extract-plugin
export default {"shedon":"ChatPopup_shedon__tLVdD"};